
import { call, put, takeEvery } from 'redux-saga/effects'

import {
    clearActionType,
    createActionTypes,
    //checkOperationResult,
    setOperationError,
    //setOperationStart
} from '../common/client/sagas/common';

import { knDataExec } from './serverApi/project';

export const GET_KATUZE_INFO_ACTION_TYPE = createActionTypes('iskn_actual/GET_KATUZE_INFO');

export default function getActions(dispatch) {
    return {
        getKatuzeInfo: (token, projectId, katuzeKod) => dispatch({
            type: GET_KATUZE_INFO_ACTION_TYPE.DEFAULT, token, projectId, katuzeKod,
            operation: GET_KATUZE_INFO_ACTION_TYPE.DEFAULT
        })
    };
}

function* workGetKatuzeInfo(options, title, action) {
    try {
        yield call(clearActionType);
        //yield call(setOperationStart, {title: title});
        yield put({type: GET_KATUZE_INFO_ACTION_TYPE.LOADING});
        const data = yield call(knDataExec, options.serverApi, action);
        yield put({type: GET_KATUZE_INFO_ACTION_TYPE.SUCCESS, data});
        //yield call(checkOperationResult, data.result, {title: title});
    } catch (error) {
        yield call(setOperationError, error, GET_KATUZE_INFO_ACTION_TYPE);
    }
}

export function* watchGetKatuzeInfo(options) {
    yield takeEvery(
        GET_KATUZE_INFO_ACTION_TYPE.DEFAULT, workGetKatuzeInfo, options,
        'Načtení informací o katastrálních území'
    );
}
